import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { TranslateService } from '../../services/translation/translate.service';
import { ClientService } from '../../services/client/client.service';
import { languageRegionCodesMap } from '../../constants';
import { LanguageRegionMap } from 'src/app/types';
import { StorageService } from '../../services/storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class HomePageRedirectGuard {
  constructor(
    private router: Router,
    private translate: TranslateService,
    private clientService: ClientService,
    private storageService: StorageService
  ) {}

  public async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree
  > {

    const lang = this.translate.findActiveLanguage();

    try {
      this.storageService.set('selectedLanguage', lang);
      await this.clientService.setClientV2({
        headers: { 'Accept-Language': this.clientService.getRegionCode() },
      }, true);
    } catch (error) {
      console.log('Error fetching client data');
    }

    const hasActiveLandingPage = this.clientService.client?.listOfNavbarItems?.find(i => i.isLanding);

    let landingPage = this.clientService.client?.isFullWeb
      ? 'home'
      : 'for-sale';

    if (hasActiveLandingPage) {
      landingPage = hasActiveLandingPage?.link?.slice(1, 99);
    }
    
    const homeIsLanding = landingPage === 'home';
    const currentPath = state?.url?.slice(1, 9999)?.replace(/^\w{2,3}\//, '').split('?')[0];

    if (route?.url[1]?.path !== landingPage) {
      if (homeIsLanding && currentPath === '') {
        return true;
      }
      this.router.navigate([lang, landingPage]);
    }
    
    return true;
  }
}
